import { ref, toValue, watch } from "vue";
export default function resettableValue(value, resettingField) {
    const result = ref(toValue(value));
    watch(resettingField, () => result.value = undefined);
    watch(value, () => result.value = toValue(value));
    return result;
}
